import React, { useState } from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import { useDispatch, useSelector } from 'react-redux';
import { setFontSize, setRewindTime } from '../actions/settingsActions';
import { FormControl, MenuItem, Select } from '@mui/material';
import CustomTypography from '../../../../components/mui/CustomTypography';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { useParams } from 'react-router-dom';
import { postApiRequest } from '../../../../features/axiosClient';
import { SAVE_TRANSCRIPTION_CONFIGURATION_API_URL } from '../../../../constants/ApiUrlConstants';
import { restoreRequest } from '../actions/restoreAction';
import RestoreConfirmModal from './restoreConfirmModal';
import CustomModal from '../../../../components/mui/CustomModal';
import { CustomButton } from '../../../../components/mui/CustomButton';
import { trackEvent } from '../../../../utils/ga';

const MoreModal = ({ moreShow, handleMoreShowCloseModal }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const userInfo = getUserInfo();
  const [restoreModal, setRestoreModal] = useState(false);
  const { rewindTime, fontSize } = useSelector((state) => state.settings);
  let editorDetails = useSelector((state) => state?.editorDetails?.user?.data);
  const parsedEditorDetails = editorDetails ? JSON.parse(editorDetails?.value || '') : null;
  const allowEdit = parsedEditorDetails?.Status !== 'Rework';

  const handleRewindTimeChange = async (value) => {
    dispatch(setRewindTime(value.toString()));
    const param = {
      audioFileId: id,
      userId: userInfo?.UserId,
      rewindOnPause: value.toString(),
      fontSize: null,
    };
    await postApiRequest(SAVE_TRANSCRIPTION_CONFIGURATION_API_URL, param);
  };

  const handleRestore = () => {
    dispatch(restoreRequest({ id, status: parsedEditorDetails?.Status }));
    trackEvent('restore_transcript', {
      file_id: id,
    });
    setRestoreModal(false);
    handleMoreShowCloseModal();
  };

  const handleCloseRestoreModal = () => {
    setRestoreModal(false);
  };

  const handleFontSizeChange = async (value) => {
    dispatch(setFontSize(value.toString()));
    const param = {
      audioFileId: id,
      userId: userInfo?.UserId,
      rewindOnPause: null,
      fontSize: value.toString(),
    };
    await postApiRequest(SAVE_TRANSCRIPTION_CONFIGURATION_API_URL, param);
  };

  return (
    <CustomModal
      open={moreShow}
      onClose={handleMoreShowCloseModal}
      sx={{ maxWidth: '500px', display: `${restoreModal && 'none'}` }}
    >
      <div className="preview-dropdown-header">
        More
        <HighlightOffRoundedIcon
          onClick={handleMoreShowCloseModal}
          style={{ cursor: 'pointer', opacity: 0.5, height: '28px', width: '28px' }}
        />
      </div>
      <div className="preview-dropdown-body">
        {allowEdit && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '16px' }}>
          <CustomTypography weight="medium">Restore Original Transcript</CustomTypography>{' '}
          <CustomButton variant="secondary" style={{ width: '120px' }} onClick={() => setRestoreModal(true)}>
            Restore
          </CustomButton>
        </div>}
        <div
          style={{ borderBottom: '1px solid #ccc', marginBottom: '16px', paddingBottom: '16px', paddingTop: '16px' }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <CustomTypography weight="medium">Rewind on Pause</CustomTypography>
            <FormControl variant="outlined" size="small">
              <Select
                labelId="rewind-time-label"
                defaultValue={rewindTime}
                onChange={(e) => {
                  handleRewindTimeChange(e.target.value);
                }}
              >
                <MenuItem value={1}>1 Sec</MenuItem>
                <MenuItem value={5}>5 Sec</MenuItem>
                <MenuItem value={10}>10 Sec</MenuItem>
                <MenuItem value={20}>20 Sec</MenuItem>
              </Select>
            </FormControl>
          </div>
          <CustomTypography color={'secondary'} size="mediumSmall">
            Automatically Rewind few seconds when the video is paused
          </CustomTypography>
        </div>
        <div
          style={{ borderBottom: '1px solid #ccc', marginBottom: '16px', paddingBottom: '16px', paddingTop: '16px' }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <CustomTypography weight="medium">Font Size</CustomTypography>
            <FormControl variant="outlined" size="small">
              <Select
                labelId="font-size-label"
                defaultValue={fontSize}
                onChange={(e) => {
                  handleFontSizeChange(e.target.value);
                }}
              >
                <MenuItem value={10}>10 px</MenuItem>
                <MenuItem value={12}>12 px</MenuItem>
                <MenuItem value={14}>14 px</MenuItem>
                <MenuItem value={16}>16 px</MenuItem>
                <MenuItem value={20}>20 px</MenuItem>
                <MenuItem value={24}>24 px</MenuItem>
                <MenuItem value={30}>30 px</MenuItem>
              </Select>
            </FormControl>
          </div>
          <CustomTypography color={'secondary'} size="mediumSmall">
            Set the Transcript font Size according your need
          </CustomTypography>
        </div>
      </div>
      <RestoreConfirmModal
        restoreModal={restoreModal}
        handleRestore={handleRestore}
        handleCloseRestoreModal={handleCloseRestoreModal}
      />
    </CustomModal>
  );
};

export default MoreModal;
